import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { RankableTableBodyRow } from '../../styled/rankable/TableRow';

import withDimensions from '../../hoc/withDimensions';
import TableCell from './TableCell';
import { inlineStylesIfRanking } from '../../internal/helpers';

export var RankableTableRow = function (_Component) {
  _inherits(RankableTableRow, _Component);

  function RankableTableRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RankableTableRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RankableTableRow.__proto__ || _Object$getPrototypeOf(RankableTableRow)).call.apply(_ref, [this].concat(args))), _this), _this.innerRef = function (innerRefFn) {
      return function (ref) {
        innerRefFn(ref);
        _this.props.innerRef(ref);
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RankableTableRow, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          row = _props.row,
          head = _props.head,
          isFixedSize = _props.isFixedSize,
          isRanking = _props.isRanking,
          refWidth = _props.refWidth,
          rowIndex = _props.rowIndex,
          isRankingDisabled = _props.isRankingDisabled;

      var cells = row.cells,
          key = row.key,
          restRowProps = _objectWithoutProperties(row, ['cells', 'key']);

      var inlineStyles = inlineStylesIfRanking(isRanking, refWidth);

      if (!row.key) {
        throw new Error('dynamic-table: ranking is not possible because table row does not have a key. Add the key to the row or disable ranking.');
      }

      return React.createElement(
        Draggable,
        {
          draggableId: key,
          index: rowIndex,
          isDragDisabled: isRankingDisabled
        },
        function (provided, snapshot) {
          return [React.createElement(
            RankableTableBodyRow,
            _extends({}, restRowProps, provided.dragHandleProps, provided.draggableProps, {
              innerRef: _this2.innerRef(provided.innerRef),
              style: _extends({}, provided.draggableProps.style, inlineStyles),
              isRanking: isRanking,
              isRankingItem: snapshot.isDragging
              // we have to pass key here, because array of two elements (RankableTableRow and placeholder) is returned
              // without key we will get react-warning-keys exception
              , key: 0
            }),
            cells.map(function (cell, cellIndex) {
              var headCell = (head || { cells: [] }).cells[cellIndex];

              return React.createElement(TableCell, {
                head: headCell,
                cell: cell,
                isRanking: isRanking,
                key: cellIndex // eslint-disable-line react/no-array-index-key
                , isFixedSize: isFixedSize
              });
            })
          )];
        }
      );
    }
  }]);

  return RankableTableRow;
}(Component);

export default withDimensions(RankableTableRow);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dynamic-table/dist/esm/components/rankable/TableRow.js
// module id = 894
// module chunks = 0